/**
 * Loading state component for notifications page.
 * Shown while notifications are being fetched.
 */
export function LoadingNotifications() {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand border-t-transparent" />
    </div>
  );
}
